import { HoverCard } from "components/HoverCard"
import * as S from './styles'
import { useRef } from "react"
import { IReport } from "interfaces/Report"

type PolicemanSummaryProps = {
  reports: IReport[] | undefined;
}

export function PolicemanSummary({ reports }: PolicemanSummaryProps) {
  const hoverCardContainerRef = useRef<HTMLDivElement>(null)

  if (!reports) return null

  if (reports.length === 0) {
    return (
      <p>Nenhum pronta-resposta associado!</p>
    )
  }

  return (
    <div>
      <div className="pr-status-hover-cards">
        <S.HoverCardContainer ref={hoverCardContainerRef}>
          <HoverCard.Root>
            <HoverCard.Trigger className="hover-card-trigger">
              Ver PR's associados
            </HoverCard.Trigger>

            <HoverCard.Content
              className="hover-card-content"
              contentContainer={hoverCardContainerRef.current}
            >
              <S.HoverInfo>
                {reports.map((report) => {
                  const policemanName = report.policeman?.user?.name
                  const superficialPolicemanName = report.superficialPoliceman?.name

                  return (
                    policemanName ? (
                      <div className="pr-info">
                        <span>{policemanName}</span>
                        <span>Registrado</span>
                      </div>
                    ) : (
                      <div className="pr-info">
                        <span>{superficialPolicemanName}</span>
                        <span>Avulso</span>
                      </div>
                    )
                  )
                })}
              </S.HoverInfo>
            </HoverCard.Content>
          </HoverCard.Root>
        </S.HoverCardContainer>
      </div>
    </div>
  )
}